export default "__VITE_ASSET__D$FbPA0i__"